// components
import ProductsList from "./components/ProductsList";

const App = () => {
  return (
    <div>
      <ProductsList />
    </div>
  );
};

export default App;
